import {
  takeLatest,
  put,
  call,
  select,
} from 'redux-saga/effects';
import { autoRequest } from '@api/createRequestStore';
import { getDimensionData } from '@api/dimensionContainer';
import { message } from 'antd';
import { payloadSelector } from './selectors';
import * as actions from './actions';
import * as types from './types';

function* init() {
  yield put(actions.initRequest());
}

function* fetching() {
  const payload = yield select(payloadSelector);
  if (!payload) {
    return;
  }

  try {
    yield call(autoRequest, getDimensionData, types.SCOPE, payload);
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchInit() {
  yield takeLatest([
    types.INIT,
  ], init);
}

function* watchFetching() {
  yield takeLatest([
    actions.fetching().type,
  ], fetching);
}

export default [
  watchInit,
  watchFetching,
];
